(() => {
  // const form = document.getElementById("mot-questionnaire-form");
  const startYes = document.getElementById("start-yes");
  const startNo = document.getElementById("start-no");
  startYes.addEventListener("click", ev => {
    ev.preventDefault();
    document.getElementById("questionnaire-btn").style.display = "flex";
    nextPrev(1);
  });
  startNo.addEventListener("click", ev => {
    ev.preventDefault();
  });

  let scores = [0, 0, 0, 0];
  let normalizedScores = [];
  const inputs = document.querySelectorAll("input");
  const classList = document.getElementById("nextBtn").classList;
  const form = document.getElementById("mot-questionnaire-form");
  let tabs = document.getElementsByClassName("tab");
  let tabExplanations = document.getElementsByClassName("tab-explanation");
  let tabsContainers = document.getElementsByClassName("tabs-container");
  let categoriesSizes = form.dataset.questionsCategoriesSizes;
  categoriesSizes = categoriesSizes.split(",");
  categoriesSizes[0] = Number(categoriesSizes[0]);
  for (let i = 1; i < categoriesSizes.length; i++) {
    categoriesSizes[i] = Number(categoriesSizes[i]);
  }
  // categoriesSizes.unshift(1);
  let categoryBreakpoints = [categoriesSizes[0]];
  for (let i = 1; i < categoriesSizes.length; i++) {
    categoryBreakpoints.push(
      Number(categoriesSizes[i]) + Number(categoryBreakpoints[i - 1])
    );
  }
  const totalSteps = form.dataset.questionsSize;

  nextBtn.addEventListener("click", event => {
    nextPrev(1);
    classList.remove("valid");
  });
  inputs.forEach(val => {
    if (val.checked) {
      if (!classList.contains("valid")) {
        classList.add("valid");
      }
    }
    val.addEventListener("change", event => {
      if (!classList.contains("valid")) {
        classList.add("valid");
      }
      return;
    });
  });

  var currentTab = 0; // Current tab is set to be the first tab (0)
  let currentTabsContainer = 0;
  showTab(currentTab); // Display the current tab

  function showTab(n) {
    // This function will display the specified tab of the form ...
    // x[n].style.display = "block";
    if (categoryBreakpoints.includes(n) || n == 0) {
      tabsContainers[currentTabsContainer]?.classList.add("done");
    }
    tabs[n].classList.add("done");
    tabExplanations[n].classList.add("done");

    // ... and fix the Previous/Next buttons:
    if (n == tabs.length - 1) {
      document
        .getElementById("nextBtn")
        .getElementsByTagName("span").innerHTML = "send";
      document.getElementsByClassName("step-progress")[0].innerHTML = `Step ${
        n + 1
      }/${totalSteps}`;
    } else {
      document
        .getElementById("nextBtn")
        .getElementsByTagName("span").innerHTML = "ok";
      document.getElementsByClassName("step-progress")[0].innerHTML = `Step ${
        n + 1
      }/${totalSteps}`;
    }
    // ... and run a function that displays the correct step indicator:
    //   fixStepIndicator(n);
  }

  function nextPrev(n) {
    // This function will figure out which tab to display
    // Exit the function if any field in the current tab is invalid:
    if (!validateForm()) return false;
    // Hide the current tab:
    if (categoryBreakpoints.includes(currentTab + n)) {
      // tabsContainers[currentTabsContainer].style.display = "none";
      tabsContainers[currentTabsContainer].classList.add("gone");
      currentTabsContainer += n;
    }
    // tabs[currentTab].style.display = "none";
    // tabExplanations[currentTab].style.display = "none";
    tabs[currentTab].classList.add("gone");
    tabExplanations[currentTab].classList.add("gone");
    // Increase or decrease the current tab by 1:
    currentTab = currentTab + n;
    // if you have reached the end of the form... :
    if (currentTabsContainer >= tabsContainers.length) {
      document
        .querySelector(".mot-questionnaire-container")
        .classList.add("d-none");
      document.getElementById("questionnaire-result").classList.add("done");
      calculateScores();
      document
        .querySelectorAll("#questionnaire-result .questionnaire-result")
        .forEach((value, key) => {
          const i = key + 1;
          value.querySelector("h1").innerHTML = `${normalizedScores[i]}/10`;
          let scoreResultText;
          let scoreResultLongText;
          if (normalizedScores[i] < 3) {
            scoreResultText = "Help is at hand!";
          } else if (normalizedScores[i] < 5) {
            scoreResultText = "Room to improve";
          } else if (normalizedScores[i] < 8) {
            scoreResultText = "Not bad!";
          } else {
            scoreResultText = "Congratulations!";
          }
          if (i === 1) {
            if (normalizedScores[i] >= 5)
              scoreResultLongText = `Congratulations, from your responses you appear to be a digital hero!  
              It would be great to see you at future Menta Networking events where you can continue to grow your business and  share your brand with others.`;
            else
              scoreResultLongText = `Don't worry we are here to help!!
              Please head over <a href="https://store.menta.org.uk/collections/springboard">here</a> to book onto the How to Build Your Presence Online or access a range of helpful guides on <a href="https://menta.mylearningapp.com/">Knowledge Hub</a>`;
          } else if (i === 2) {
            if (normalizedScores[i] >= 5)
              scoreResultLongText = `Congratulations, from your responses you appear to be a marketing guru!!  
              To maintain your good work keep checking back to our <a href="https://menta.mylearningapp.com/">Knowledge Hub</a> where you will find refreshing tips and advice to keep your marketing moving.`;
            else
              scoreResultLongText = `Don't worry we are here to help!!
              Please head over <a href="https://store.menta.org.uk/collections/springboard">here</a> to book onto the How to Build Your Presence Online or access a range of helpful guides on <a href="https://menta.mylearningapp.com/">Knowledge Hub</a>`;
          } else if (i === 3) {
            if (normalizedScores[i] >= 5)
              scoreResultLongText = `Congratulations, from your responses you appear to be a online wizard!!  
              However, there is always more to learn.  The Digital Springboard Programme will continue to adapt to the changing retail environment so please check regularly for new events and tools that can help keep you ahead of the game.`;
            else
              scoreResultLongText = `Don't worry you are not alone!!
              That is why the Digital Springboard is helping many others like you with busy life's to access a range of fully funded practical support and advice.  Head to <a href="https://store.menta.org.uk/collections/springboard">our store</a> to explore what events we have on offer or reach out to us for a quick chat with one of our friendly Springboard Team who can help direct to the right solution for you.`;
          }
          value.querySelector("h4").innerHTML = scoreResultText;
          value.querySelector("p").innerHTML = scoreResultLongText;
        });
      return;
    }
    // Otherwise, display the correct tab:
    showTab(currentTab);
  }

  function validateForm() {
    // This function deals with validation of the form fields
    let x = document.getElementsByClassName("tab");
    let y = x[currentTab].getElementsByTagName("input");
    if (y.length === 0) return true;

    const valid = [...y].reduce(
      (prev, current) => current.checked || prev,
      false
    );

    if (!valid) {
      if (!x[currentTab].classList.contains("invalid")) {
        x[currentTab].classList.add("invalid");
      }
    }

    scores[currentTabsContainer] += Number(
      x[currentTab].querySelector("input:checked") != null
        ? x[currentTab].querySelector("input:checked").value
        : 0
    );

    return valid; // return the valid status
  }

  function calculateScores() {
    for (let i = 0; i < scores.length; i++) {
      const scoreAvg = scores[i] / categoriesSizes[i];

      const translatedScoreAvg = ((scoreAvg - 1) / 4) * 10;
      normalizedScores.push(Math.round(translatedScoreAvg));
    }
  }
})();
